export default "__VITE_ASSET__1y3_Py0r__"